// Sentry initialization should be imported first!
import './vendor/sentry.js'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App.jsx'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
)
